import React from "react";
import { Container } from "@mui/material";

const LoaderContainer = ({ loading, children }) => {
  if (loading) {
    return (
      <Container
        maxWidth="xs"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <img
          src="https://i.gifer.com/7YQl.gif"
          alt="loader"
          style={{ width: "180px" }}
        />
      </Container>
    );
  } else {
    return <>{children}</>;
  }
};

export default LoaderContainer;
